module.exports = __webpack_public_path__ + "img/img5.f1577b7e.png";